module.exports = __webpack_public_path__ + "img/trash2.96e76f82.svg";